import {PermissionService} from "@/services/PermissionService.ts";

import {Result} from "@/utils/types.ts";

type LocalActionHandler = <T>(payload?: any) => Promise<Result<T>>;

export const LocalActionsRegistry: Record<string, LocalActionHandler> = {
    openQrScannerForAuth: async () =>  await PermissionService.scanAndProcess(true),
    openQrScanner: async () => await PermissionService.scanAndProcess(false)
};